import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import constants from "../../utils/constants";
import FileDropzone from "../DicomUpload/FileDropzone";
import useWorkspacePermittedData from "../WorkspaceManagement/services/useWorkspacePermittedData";
import useCsvUpload from "../../hooks/useCsvUpload";
import SelectWorkspace from "../SelectWorkspace";
import saveFile from "../../utils/saveFile";
import { useAuth } from "@qure/qure-auth";
function UploadView() {
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var _useWorkspacePermitte = useWorkspacePermittedData(true, constants.WORKSPACE_USER_ROLES.WORKSPACE_PATIENT_WRITE),
    data = _useWorkspacePermitte.data,
    isLoading = _useWorkspacePermitte.isLoading;
  var _useState = useState(null),
    selectedWorkspace = _useState[0],
    setSelectedWorkspace = _useState[1];
  var listOfWorkspacesRef = useRef();
  var _useCsvUpload = useCsvUpload(),
    _useCsvUpload2 = _slicedToArray(_useCsvUpload, 2),
    dispatch = _useCsvUpload2[1];
  useEffect(function () {
    var _data$filter, _listSource$find;
    if (isLoading) return;
    var listSource = data === null || data === void 0 || (_data$filter = data.filter(function (src) {
      return !src.data_hidden;
    })) === null || _data$filter === void 0 ? void 0 : _data$filter.map(function (src) {
      return {
        label: src.name,
        value: src.id,
        id: src.uuid,
        role: src.role,
        has_permission: src.has_permission,
        synced: src.synced
      };
    });
    var defaultWorkspace = (_listSource$find = listSource === null || listSource === void 0 ? void 0 : listSource.find(function (item) {
      return String(item.value) === String(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace);
    })) !== null && _listSource$find !== void 0 ? _listSource$find : null; //  this is bad

    setSelectedWorkspace(defaultWorkspace);
    listOfWorkspacesRef.current = listSource;
  }, [isLoading]);
  if (isLoading) {
    return;
  }
  if (!listOfWorkspacesRef.current) {
    return;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FileDropzone, {
    className: "h-full",
    acceptedFiles: ".csv",
    onDropFiles: function onDropFiles(files) {
      console.log("hello", files);
      // const formData = new FormData();
      // formData.append("file", files[0]);

      // const workspaceId = selectedWorkspace?.value;
      // const URL = `workspaces/${workspaceId}/patients/generate_report_summary/`;
      // servicesUtils.postService(URL, formData);
      dispatch({
        type: "submit-for-validation",
        payload: {
          file: files[0],
          selectedWorkspace: selectedWorkspace
        }
      });
    },
    isDropzoneDisabled: false,
    isHidden: false
  }, function (_ref) {
    var open = _ref.open;
    return /*#__PURE__*/React.createElement("div", {
      className: "h-[340px] flex flex-col justify-center items-center"
    }, /*#__PURE__*/React.createElement(SelectWorkspace, {
      selectedSource: selectedWorkspace,
      setSelectedSource: setSelectedWorkspace,
      siteOptions: listOfWorkspacesRef.current
    }), /*#__PURE__*/React.createElement("div", {
      className: "py-6"
    }, /*#__PURE__*/React.createElement("p", {
      className: "my-2"
    }, "Drag and Drop here"), /*#__PURE__*/React.createElement("p", {
      className: "text-gray-600 text-md"
    }, "(Only .csv files are supported)"), /*#__PURE__*/React.createElement("span", {
      className: "flex justify-center text-gray-600 my-7"
    }, /*#__PURE__*/React.createElement("p", {
      className: "tracking-[3px]"
    }, "----------------"), /*#__PURE__*/React.createElement("p", {
      className: "mx-4 uppercase"
    }, "or"), /*#__PURE__*/React.createElement("p", {
      className: "tracking-[3px]"
    }, "----------------")), /*#__PURE__*/React.createElement("span", {
      className: "flex flex-col items-center"
    }, /*#__PURE__*/React.createElement("button", {
      className: "w-[156px] h-[48px] bg-teal-500 text-base rounded-6",
      onClick: open
    }, "Select Files"), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        fetch("".concat(process.env.NEXT_PUBLIC_TRANSLATION_URL, "/PatientUploadTemplate.csv")).then(function (res) {
          return res.blob();
        }).then(function (res) {
          saveFile(res, {
            fileName: "template.csv",
            type: "text/csv;charset=utf-8;"
          });
        });
      },
      className: "text-sm mt-3 text-gray-500 hover:underline"
    }, "Download template"))));
  }));
}
export default UploadView;